import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { ISibasiHTTPResponse } from 'src/app/common/model/sibasiHTTPResponse.model';
import { IPagination } from 'src/app/common/model/util.model';
import { EStockStatus, IItem } from '../../models/item.model';

@Injectable({
  providedIn: 'root'
})
export class ItemsService {
  public itemInStock = new BehaviorSubject(0);
  currentItemsInStock = this.itemInStock.asObservable();

  public itemStockStatus = new BehaviorSubject<EStockStatus | undefined>(undefined);
  currentStockStatus = this.itemStockStatus.asObservable();

  constructor(private http: HttpClient) {}

  public getItems(): Observable<ISibasiHTTPResponse<IItem[]>> {
    return this.http.get<ISibasiHTTPResponse<IItem[]>>(`${environment.api_url}pos/item`);
  }

  changeItemsStock(itemsInStock: number | undefined) {
    if (itemsInStock !== undefined && itemsInStock !== null) {
      this.itemInStock.next(itemsInStock);
    }
  }

  setInitialStockStatus(initialStatus: EStockStatus) {
    this.itemStockStatus.next(initialStatus);
  }

  changeStockStatus(itemStockStatus: EStockStatus | undefined) {
    itemStockStatus ? this.itemStockStatus.next(itemStockStatus) : '';
  }

  public getItem(itemId: any): Observable<ISibasiHTTPResponse<IItem>> {
    return this.http.get<ISibasiHTTPResponse<IItem>>(
      `${environment.api_url}pos/item/${itemId}`
    );
  }

  public addItem(item: any): Observable<ISibasiHTTPResponse<IItem>> {
    return this.http.post<ISibasiHTTPResponse<IItem>>(
      `${environment.api_url}pos/item`,
      item
    );
  }
  public addBulkItems(items: []): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/item/bulk/add`,
      items
    );
  }
  public addBulkItemsWithQuantityUpdate(items: []): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/item/bulk/add/checkQuantity`,
      items
    );
  }
  public deleteItem(itemId: any) {
    return this.http.delete(`${environment.api_url}pos/item/${itemId}`);
  }
  public bulkDeleteItems(itemIds: any) {
    return this.http.post(`${environment.api_url}pos/item/delete/many`, itemIds);
  }

  public editItem(itemId: any, item: {}): Observable<ISibasiHTTPResponse<IItem>> {
    return this.http.post<ISibasiHTTPResponse<IItem>>(
      `${environment.api_url}pos/item/${itemId}`,
      item
    );
  }
  getAllItemsCount(): Observable<ISibasiHTTPResponse<number>> {
    return this.http.get<ISibasiHTTPResponse<number>>(
      `${environment.api_url}pos/item/all/count`
    );
  }

  getAllSearchedItemsCount(searchParam: string): Observable<ISibasiHTTPResponse<number>> {
    return this.http.post<ISibasiHTTPResponse<number>>(
      `${environment.api_url}pos/item/all/count/searched`,
      { searchParam }
    );
  }

  getPaginatedItems(pagination?: any) {
    return this.http.post<ISibasiHTTPResponse<IPagination<IItem[]>>>(
      `${environment.api_url}pos/item/all/paginated`,
      pagination ? pagination : {}
    );
    // .pipe(
    //     map((res) => {
    //         const items =
    //             res.result?.length > 0
    //                 ? res.result.slice().reverse()
    //                 : [];
    //         return {
    //             ...res,
    //             result: items,
    //         };
    //     })
    // );
  }

  getStockMetrics(): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/item/management/stockCheck`
    );
  }
}
